module.exports = __webpack_public_path__ + "img/gyroids.908a5d6d.svg";